export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/wmd-logo-warmup-spanish-425aba8e894ed37bc437aae9818a97b9.svg";